export default __webpack_public_path__ + "static/media/pictogramTravel48.142755a5.svg";